<div class="tw-flex tw-flex-row tw-items-center">
    <button [disabled]="!scanIsClean"
            matTooltip="{{ filename }}"
            matTooltipPosition="above"
            (click)="viewDocument()"
            class="tw-bg-transparent tw-border-none tw-p-0 tw-text-left tw-cursor-pointer hover:tw-text-blue-600">
        <span [class]="scanIsClean ? 'tw-text-blue-600 tw-underline' : 'tw-text-gray-400'">{{ filename | truncate: [40, '...'] }}</span>
    </button>
</div>
